<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.transfer_history")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-8.col-xl-6.mb-1
                DatePicker
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.account_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="search_id"
                    :placeholder='$t("ui.account_id")'
                    v-model="search_id"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="settlementHistoryList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(transaction_date)="row")
                    span {{ $moment(row.item.transaction_date).format("YYYY-MM-DD HH:mm:ss") }}
                  template(v-slot:cell(account_id)="row")
                    span {{ row.item.account_id.toUpperCase() }}
                  template(v-slot:cell(settled_amount)="row")
                    span(:class="$helpers.getNumberClass(row.item.settled_amount)") #[b {{ row.item.settled_amount | currency }} ]
                  template(v-slot:cell(account_before_balance)="row")
                    template(v-if="['MMK','MMO'].includes(row.item.currency_code) && isCashMode")
                      span(:class="$helpers.getNumberClass(row.item.cash_before_balance)") #[b {{ row.item.cash_before_balance | currency }} ]
                    template(v-else)
                      span(:class="$helpers.getNumberClass(row.item.account_before_balance)") #[b {{ row.item.account_before_balance | currency }} ]
                  template(v-slot:cell(account_after_balance)="row")
                    template(v-if="['MMK','MMO'].includes(row.item.currency_code) && isCashMode")
                      span(:class="$helpers.getNumberClass(row.item.cash_after_balance)") #[b {{ row.item.cash_after_balance | currency }} ]
                    template(v-else)
                      span(:class="$helpers.getNumberClass(row.item.account_after_balance)") #[b {{ row.item.account_after_balance | currency }} ]
                  template(v-slot:bottom-row="row" v-if="showTotal")
                    td.text-right(colspan="5")
                      span #[b {{ $t("ui.sub_total") }}]
                      br
                      span #[b {{ $t("ui.grand_total") }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalSettledAmount)" style="padding:0;") #[b {{ subTotalSettledAmount | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalSettledAmount)") #[b {{ grandTotalSettledAmount | currency }} ]
                    td(colspan="2")
</template>

<script>
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DatePicker from "@/library/DatePicker.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DatePicker
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      search_id: this.$store.getters.getSelectedID,
      settlementHistoryList: [],
      subTotalSettledAmount: 0,
      grandTotalSettledAmount: 0,
      showTotal: false,
      filter: null,
      sortBy: "transaction_date",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0
    };
  },
  validations: {},
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      }
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "transaction_date",
          label: this.$t("ui.transaction_date"),
          sortable: true,
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "transfer_method",
          label: this.$t("ui.transfer_method"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "remark",
          label: this.$t("ui.remark"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
        },
        {
          key: "settled_amount",
          label: this.$t("ui.amount"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "account_before_balance",
          label: this.$t("ui.account_before_balance"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "account_after_balance",
          label: this.$t("ui.account_after_balance"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "13%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function() {
    this.submit()
  },
  methods: {
    isCashMode() {
      return this.$store.getters.cashMode
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    submit: function() {
      if (!this.$v.$invalid) {
        let search_id = this.search_id
        let start_date = this.dateRange.startDate
        let end_date = this.dateRange.endDate
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch("user/getSettlementHistory", { search_id, start_date, end_date, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.clearTotal()
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.showTotal = true
                this.settlementHistoryList = response.data
                this.totalRows = response.data.length > 0 ? this.settlementHistoryList[0]["totalrows"] : 0

                response.data.forEach(value => {
                  this.subTotalSettledAmount = parseFloat(this.subTotalSettledAmount) + parseFloat(value["settled_amount"]);
                })

                if(response.grandTotal.length > 0) {
                  this.grandTotalSettledAmount = response.grandTotal[0]["settled_amount"];
                }
              } else {
                this.clearTotal()
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.clearTotal()
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    },
    clearTotal() {
      this.$store.dispatch("user/setSelectedID", "")
      this.showTotal = false
      this.settlementHistoryList = []
      this.totalRows = 0
      this.subTotalSettledAmount = 0
      this.grandTotalSettledAmount = 0
    }
  }
};
</script>

